﻿import React, { useContext, useEffect } from 'react';
import { BookingFlowContext } from '../BookingFlowContext'
import { shouldAccountBeUpdated } from '../../../../../Resources/Scripts/_Shared/helpers';

export const BackNavigation = ({ disabled = false }) => {
  const { bookingFlowContext, setBookingFlowContext } = useContext(BookingFlowContext);
  const backHandler = () => {
    const newActiveStep = ReturnPreviousStep(bookingFlowContext)
    setBookingFlowContext({ ...bookingFlowContext, activeStep: newActiveStep })
  };

  useEffect(() => {
    const initPopstateListener = (e) => {
      if (e.state && e.state?.activeStep !== null && e.state.activeStep < bookingFlowContext.activeStep)
        backHandler();
    }

    window.addEventListener('popstate', initPopstateListener);
    return () => { window.removeEventListener('popstate', initPopstateListener); }
  }, [bookingFlowContext.availableSteps.onlineBooking.order])

const clickHandler = () => {
  const activeStep = ReturnPreviousStep(bookingFlowContext);
  setBookingFlowContext({ ...bookingFlowContext, activeStep });
  if (!bookingFlowContext.episerver.hasWebticketAccount && activeStep === bookingFlowContext.availableSteps.onlineBooking.index) location.reload(); 
}

  return (
    <button className="bookingflowpage__back" disabled={disabled} onClick={clickHandler}>{bookingFlowContext.localization.global.buttons.previousStep}</button>
  )
}

export const ReturnPreviousStep = (bookingFlowContext) => {
  if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.login.index) {
    //Login selection
    return bookingFlowContext.availableSteps.onlineBooking.index;
  }
  else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.createAccount.index) {
    //Create account
    // if (bookingFlowContext.user || bookingFlowContext.episerver.loggedIn)
       return bookingFlowContext.availableSteps.onlineBooking.index;
    // else
     // return bookingFlowContext.availableSteps.login.index;
  }
  else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.addVehicle.index) {
    //Add vehicle
    // if(bookingFlowContext.user) {
      return bookingFlowContext.availableSteps.onlineBooking.index;
    // }
    // else {
    //   return bookingFlowContext.availableSteps.login.index;
    // }
  }
  else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.orderOverview.index) {
    //Order overview
      return bookingFlowContext.availableSteps.addVehicle.index;
  }
}
